import React, { useEffect, useState } from "react";
import api from "../../utils/api";
import APIConstant from "../../utils/constant";
import Loader from "components/Shared/Loader/Loader";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { InputSwitch } from "primereact/inputswitch";
import cogoToast from "cogo-toast";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

const ScheduleReport = (props) => {
  const [scheduleList, setScheduleList] = useState([]);
  const [userPageAccess, setUserPageAccess] = useState([]);
  const [filteredScheduleList, setFilteredScheduleList] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [userId, setUserId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [reportId, setReportId] = useState("");

  useEffect(() => {
    const data = localStorage.getItem("Infodata");
    const token = localStorage.getItem("Token");
    const access = localStorage.getItem("PageAccess");

    if (token) {
      setUserId(data);
      getScheduleList(data);
      setUserPageAccess(access);
      setUserId(data);
    } else {
      props.history.push("/login");
    }
  }, []);

  const getScheduleList = async (uid) => {
    try {
      //   Loader.show();
      const res = await api.post(APIConstant.path.GetScheduleReportList, {
        UserId: uid,
      });
      if (res.Success === 1) {
        setScheduleList(res.Data);
        setFilteredScheduleList(res.Data);
      } else {
        setScheduleList([]);
        setFilteredScheduleList([]);
      }
      Loader.hide();
    } catch (err) {
      console.log(err);
      Loader.hide();
    }
  };

  const handleGlobalFilter = (e) => {
    const value = e.target.value;
    setGlobalFilter(value);
    const filtered = scheduleList.filter((item) =>
      item.ReportType.toLowerCase().includes(value.toLowerCase())
    );
    setFilteredScheduleList(filtered);
  };

  const handleToggleActive = async (rowData) => {
    try {
      Loader.show();
      const payload = {
        ...rowData,
        IsActive: !rowData.IsActive,
        ScheduleId: rowData._id,
        UserId: userId,
      };
      const res = await api.post(
        APIConstant.path.AddUpdateScheduleReport,
        payload
      );
      if (res.Success === 1) {
        cogoToast.success("Status updated successfully");
        getScheduleList(userId);
      } else {
        cogoToast.error(res.Message);
      }
      Loader.hide();
    } catch (err) {
      console.log(err);
      Loader.hide();
    }
  };

  const handleDelete = async () => {
    try {
      Loader.show();
      const res = await api.post(APIConstant.path.DeleteScheduleReport, {
        ScheduleId: reportId,
        UserId: userId,
      });
      if (res.Success === 1) {
        cogoToast.success(res.Message);
        getScheduleList(userId);
        setShowDeleteModal(false);
        setReportId("");
      } else {
        cogoToast.error(res.Message);
      }
      Loader.hide();
    } catch (err) {
      console.log(err);
      Loader.hide();
    }
  };

  const handleOpen = (data = {}, type = "Add") => {
    if (type === "Delete") {
      setShowDeleteModal(true);
      setReportId(data._id);
    }
  };

  const actionBodyTemplate = (rowData) => (
    <div className="p-d-flex icon-only-btn">
      {userPageAccess?.includes("Edit Schedule Report") && (
        <i
          className="icon-editImage"
          onClick={() =>
            props.history.push({
              pathname: "/admin/add-schedule-report",
              state: { scheduleId: rowData._id },
            })
          }
        ></i>
      )}

      {userPageAccess?.includes("Delete Schedule Report") ? (
        <div onClick={(e) => handleOpen(rowData, "Delete")}>
          <i class="icon-delete"></i>{" "}
        </div>
      ) : null}
    </div>
  );

  const activeBodyTemplate = (rowData) => {
    return (
      <InputSwitch
        checked={rowData.IsActive}
        onChange={() => handleToggleActive(rowData)}
      />
    );
  };

  return (
    <div className="wayment-owner-dashboard e-weighment-dashoard">
      <div className="heading-area p-d-flex p-ai-center p-jc-between">
        <div className="p-d-flex p-ai-center">
          <i className="pi pi-calendar-plus"></i>
          <h2>Schedule Reports</h2>
        </div>
        <div className="p-d-flex p-ai-center wb-filter-btn">
          <div className="searchbar-area p-position-relative">
            <InputText
              className="searchbar"
              value={globalFilter}
              onChange={handleGlobalFilter}
              placeholder="Global Search"
              size="30"
              style={{ marginRight: 30 }}
            />
            {!globalFilter && <i className="icon-search"></i>}
          </div>
          <div
            className="e-add-btn"
            onClick={() => props.history.push("/admin/add-schedule-report")}
          >
            <i className="icon-add"></i>
          </div>
        </div>
      </div>
      <hr />
      <div className="main-access-card-master">
        <DataTable
          value={filteredScheduleList}
          paginator
          rows={10}
          totalRecords={filteredScheduleList.length}
          editMode="row"
          dataKey="id"
          className="main-table table-td e-company-table"
          emptyMessage="No records found"
          responsiveLayout="scroll"
          responsive={false}
          resizableColumns={true}
          columnResizeMode="fit"
          scrollable={true}
          scrollWidth="auto"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
        >
          <Column field="ReportType" header="Report Type" sortable />
          <Column field="Frequency" header="Frequency" sortable />
          <Column field="TimeOfDay" header="Time" sortable />
          <Column field="EmailTo" header="Email To" sortable />
          <Column
            field="IsActive"
            header="Active"
            body={activeBodyTemplate}
            sortable
          />
          <Column
            header="Actions"
            body={actionBodyTemplate}
            headerStyle={{ width: "10%", minWidth: "8rem" }}
            bodyStyle={{ textAlign: "center" }}
          />
        </DataTable>
      </div>
      <Dialog
        open={showDeleteModal}
        onClose={() => {
          setShowDeleteModal(false);
          setReportId("");
        }}
        aria-labelledby="cha-form-dialog-title"
      >
        <DialogTitle
          id="cha-form-dialog-title"
          className="custom-dialog-header"
        >
          <div>Delete Schedule</div>
          <div
            className="dialog-close"
            onClick={() => {
              setShowDeleteModal(false);
              setReportId("");
            }}
          >
            <i className="icon-modal-close"></i>
          </div>
        </DialogTitle>
        <DialogContent className="CHA-dialog-content-area">
          <h6>Are you sure want to delete this?</h6>
        </DialogContent>
        <DialogActions className="p-p-0 dialog-footer1">
          <Button
            className="primary-btn1"
            onClick={() => {
              setShowDeleteModal(false);
              setReportId("");
            }}
          >
            Close
          </Button>
          <Button
            className="primary-btn"
            onClick={(e) => handleDelete(e)}
            type="submit"
          >
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default ScheduleReport;
